// extracted by mini-css-extract-plugin
export default {"userBar":"userBar_userBar__SJ7c6","bell":"userBar_bell__1oMlJ","setting":"userBar_setting__rngJo","user":"userBar_user__bi5go"};